var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"title"},[_vm._v("8大场景，轻松实现业务需求")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("\n    不同的客户，不同的行业，共同的选择，赛码为您提供专业的解决方案\n  ")])])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/scene/banner.vue?vue&type=template&id=f6464160&scoped=true
// module id = null
// module chunks = 